export const emailRecipientTypeConstants = {
  From: 1,
  To: 2,
  CC: 3,
}

export const emailRecipientTypeStrings = {
  Empty: '',
  From: 'From',
  To: 'To',
  CC: 'CC',
}
